import { Alert } from "components/common/Alert/Alert";
import { useTranslationContext } from "context/translation";
import { FC, useEffect, useState } from "react";
import { FlagAndNoteProps } from "../common/types";

export const FlagAndNote: FC<FlagAndNoteProps> = ({
  blockedItem,
  isGuest,
  lowStock,
  outOfStock,
  product,
  remainingInventory,
  subscriptionIntervalInDays,
  updateCartItem,
}) => {
  const { outOfStockError, quantityUpdatedWarning } = useTranslationContext();

  const [quantityUpdated, setQuantityUpdated] = useState(false);

  useEffect(() => {
    if (!product.id || !product.inventoryQty || quantityUpdated) return;
    if (lowStock && updateCartItem) {
      updateCartItem({
        productId: product.id,
        quantity: product.inventoryQty,
        subscriptionIntervalInDays,
      }).then(() => {
        setQuantityUpdated(true);
      });
    }
  }, [
    product,
    subscriptionIntervalInDays,
    lowStock,
    updateCartItem,
    quantityUpdated,
  ]);

  if (outOfStock) {
    return (
      <Alert fullWidth type="error">
        {outOfStockError}
      </Alert>
    );
  }

  if (quantityUpdated && remainingInventory) {
    return (
      <Alert fullWidth type="warning">
        {(quantityUpdatedWarning ?? "").replace(
          "{value}",
          remainingInventory.toString(),
        )}
      </Alert>
    );
  }

  if (blockedItem) {
    return (
      <Alert fullWidth type="error">
        This product is unavailable
        {blockedItem.isZipError ? " in your region/zip code" : ""}. Please
        remove this product from your cart to complete your order.
      </Alert>
    );
  }

  if (subscriptionIntervalInDays && isGuest) {
    return (
      <Alert fullWidth type="error">
        Product subscriptions are only available by registering for an account.
        Please remove this product from your cart to proceed.
      </Alert>
    );
  }

  return null;
};
